import React from 'react';
import type { MenuProps } from 'antd';
import {  Dropdown } from 'antd';
// @ts-ignore
import { setAccessToken } from '../../../auth';
import './styles.css'

import { Avatar } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { userLogout } from '../../../actions/user';
import { UserOutlined } from '@ant-design/icons';
import { capitalizeFirstLetter, truncateText } from '@utils/comman';


const items: MenuProps['items'] = [
    {
        label: 'Profile',
        key: '1',
    },
    {
        label: 'Change Password',
        key: '2',
    },
    {
        label: 'Logout',
        key: '3',
    },
];

const DropdownUser = ({userData}: any) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleMenuClick: MenuProps['onClick'] = (e: any) => {
        if(Number(e.key) === 1) {
            userData?.roleId !==1 && navigate('/account', { state: { changePassword: false } })
        }
        if(Number(e.key) === 2) {
            userData?.roleId !==1 && navigate('/account', { state: { changePassword: true } });
        }
        if(Number(e.key) === 3) {
            dispatch(
                userLogout((resp: any) => {
                    if (resp?.success) {
                        setAccessToken('');
                        navigate('/login')
                    }
                })
            );
        }
    };

    const getProfileRole =()=> {
        switch(userData?.roleId){
            case 1: {
                return 'Super Admin'
            }
            case 2: {
                return 'Business Admin'
            }
            case 3: {
                return 'Referrer Admin'
            }
            default : {
                return ''
            }
        }
    }

    const menuProps = {
        items,
        onClick: handleMenuClick,
    };

    return (
        <>
            <Dropdown menu={menuProps}>
                <button className="btn user-menu-button">
                    <div className="user-info">
                        {userData?.profilePhoto ?
                            <Avatar src={userData?.profilePhoto} alt="avatar" /> :
                            <Avatar size={40} icon={<UserOutlined />} />
                        }
                        <div className="user-details">
                            <span className="user-name">
                                {userData?.contactName ?
                                    capitalizeFirstLetter(truncateText(userData?.contactName, 15)) :
                                    capitalizeFirstLetter(`${userData?.firstName} ${userData?.lastName}`)
                                }
                            </span>
                            <span className="user-role">{getProfileRole()}</span>
                        </div>
                    </div>
                </button>
            </Dropdown>
        </>
    );
};

export default DropdownUser;
